module.exports = {"width":1484,"height":983,"type":"png"}